import JSZip from "jszip";

export const createZipFile = (files: Array<{ file: Blob; name: string }>) => {
  const zip = new JSZip();

  files.forEach((file) => {
    zip.file(file.name, file.file);
  });

  return zip.generateAsync({ type: "blob" });
};
